import React, {Component} from 'react';
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';
import QueryString from 'query-string';

import * as UserActions from '../../../actions/userActions';
import Loader from '../../../components/commons/loader/loader';

class EmailVerification extends Component {

  constructor(props){
    super(props);
    this.state = {
      password2: '',
      showAlert: false,
      swalParams: {
        title: "Verifying email..."
      }
    }
  }

  componentDidMount() {
    const { location } = this.props;
    let params = QueryString.parse(location.search);

    this.props.dispatch(UserActions.setVerifyEmail({ token: params.token }, response => {
        if(response && response.status) {
          this.setState({showAlert: true, swalParams: {
            title: "Your email has been verified successfully",
            type: "success"
          }});
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        } else {
          this.setState({showAlert: true, swalParams: {
            title: "The verification link has expired!",
            type: "error"
          }});
        }
    }))
  }

  render() {
    const { loading } = this.props;
    const { showAlert, swalParams } = this.state;
    return (
      <div className="page reset-password-page">
        <div className="container">
          { showAlert && <h2 className="page-title">{ swalParams.title }</h2> }
        <Loader visibility={loading} />
        </div>
      </div>
    )
  }
}


export default connect((state) => {
  return {
    error: state.getIn(['users', 'error']),
    loading: state.getIn(['users', 'loading'])
  };
})(EmailVerification);



// WEBPACK FOOTER //
// ./src/containers/begin/email-verification/EmailVerification.js